__turbopack_context__.v({
  "addToCart": "work-purchase-panel-module-scss-module__8HX_pW__addToCart",
  "backorder": "work-purchase-panel-module-scss-module__8HX_pW__backorder",
  "belowMediumQuantityControl": "work-purchase-panel-module-scss-module__8HX_pW__belowMediumQuantityControl",
  "bestAvailable": "work-purchase-panel-module-scss-module__8HX_pW__bestAvailable",
  "countryRestriction": "work-purchase-panel-module-scss-module__8HX_pW__countryRestriction",
  "currencySymbol": "work-purchase-panel-module-scss-module__8HX_pW__currencySymbol",
  "dealIcon": "work-purchase-panel-module-scss-module__8HX_pW__dealIcon",
  "interestCount": "work-purchase-panel-module-scss-module__8HX_pW__interestCount",
  "listPrice": "work-purchase-panel-module-scss-module__8HX_pW__listPrice",
  "lowStock": "work-purchase-panel-module-scss-module__8HX_pW__lowStock",
  "mediumAndUpQuantityControl": "work-purchase-panel-module-scss-module__8HX_pW__mediumAndUpQuantityControl",
  "preorderQuantityControl": "work-purchase-panel-module-scss-module__8HX_pW__preorderQuantityControl",
  "price": "work-purchase-panel-module-scss-module__8HX_pW__price",
  "priceBlock": "work-purchase-panel-module-scss-module__8HX_pW__priceBlock",
  "priceValue": "work-purchase-panel-module-scss-module__8HX_pW__priceValue",
  "purchaseActions": "work-purchase-panel-module-scss-module__8HX_pW__purchaseActions",
  "purchaseDetails": "work-purchase-panel-module-scss-module__8HX_pW__purchaseDetails",
  "quantityRow": "work-purchase-panel-module-scss-module__8HX_pW__quantityRow",
  "releaseDate": "work-purchase-panel-module-scss-module__8HX_pW__releaseDate",
  "revealedStockStatus": "work-purchase-panel-module-scss-module__8HX_pW__revealedStockStatus",
  "root": "work-purchase-panel-module-scss-module__8HX_pW__root",
  "savings": "work-purchase-panel-module-scss-module__8HX_pW__savings",
  "selectedLabel": "work-purchase-panel-module-scss-module__8HX_pW__selectedLabel",
  "selectionSummary": "work-purchase-panel-module-scss-module__8HX_pW__selectionSummary",
  "shippingDetails": "work-purchase-panel-module-scss-module__8HX_pW__shippingDetails",
  "shippingEstimate": "work-purchase-panel-module-scss-module__8HX_pW__shippingEstimate",
  "shippingExclusion": "work-purchase-panel-module-scss-module__8HX_pW__shippingExclusion",
  "shippingHelp": "work-purchase-panel-module-scss-module__8HX_pW__shippingHelp",
  "shippingModal": "work-purchase-panel-module-scss-module__8HX_pW__shippingModal",
  "socialLinks": "work-purchase-panel-module-scss-module__8HX_pW__socialLinks",
  "status": "work-purchase-panel-module-scss-module__8HX_pW__status",
  "stockStatus": "work-purchase-panel-module-scss-module__8HX_pW__stockStatus",
  "u-animation-bounce": "work-purchase-panel-module-scss-module__8HX_pW__u-animation-bounce",
  "unavailable": "work-purchase-panel-module-scss-module__8HX_pW__unavailable",
  "wishListContainer": "work-purchase-panel-module-scss-module__8HX_pW__wishListContainer",
});
